import { Carateristique } from './../../../../data/http/responses/activite.response';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, TemplateRef } from "@angular/core";
import { TypeInterventionResponse } from "../../../../data/http/responses/typeintervention.response";
import { TableProgrammes } from "../../../../data/schemas/table.schema";
import { TypeInterventionService } from "../../../../services/typeintervention/typeintervention.service";
import { MatIcon } from "@angular/material/icon";
import { ModalComponent } from "../../../../components/modal/modal.component";
import { FormsModule, ReactiveFormsModule, FormGroup } from "@angular/forms";
import { StructureProgammatiqueService } from "../../../../services/structureProgrammatiquesService";
import { StructureProgrammatiqueRequest } from "../../../../data/http/requests/structureprogrammatique.req";
import { StructureProgrammatiqueResponse } from "../../../../data/http/responses/structureprogrammatique.res";
import { Input } from "../../../../components/forms/input/input";
import { AppService } from "../../../../core/app.service";
import { LoaderComponent } from "../../../../components/ui/loader/loader.component";
import { loaderIntervantion } from "../../../../components/ui/loaderIntervantion/loaderIntervantion.component";
import { UiButtonComponent } from "../../../../components/button/button.component";
import { CommonModule, formatDate, NgClass } from "@angular/common";
import { ActiviteService } from "../../../../services/activite/activite.service";
import { ActivtieResponse } from "../../../../data/http/responses/activite.response";
import { SelectComponent } from '../../../../components/forms/select/select.component';
import { SearchFilterComponent, SearchFilterValue } from '../../../../components/ui/Searchfilter/Searchfilter.component';
import { ConfirmDialogComponent } from "../../../../components/ui/Confirmdialog/Confirmdialog.component";
import { toSnakeCaseUpper } from "../../../../utils/helpers";

/** Flat row emitted by getFlatVisibleNodes() */
export interface FlatNode {
  node: StructureProgrammatiqueResponse;
  level: number;
  isResponsible: boolean;
}

@Component({
  selector: 'app-structuresprogrammatiques',
  standalone: true,
  imports: [
    MatIcon,
    ModalComponent,
    FormsModule,
    LoaderComponent,
    loaderIntervantion,
    CommonModule,
    ReactiveFormsModule,
    Input,
    UiButtonComponent,
    SelectComponent,
    SearchFilterComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './structuresprogrammatiques.component.html',
  styleUrls: ['./structuresprogrammatiques.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StructuresprogrammatiquesPage {

  // ─── ViewChild refs ────────────────────────────────────────────────────────
  @ViewChild('modalAddSub') modalAddSub!: TemplateRef<any>;
  @ViewChild('modalEdit') modalEdit!: TemplateRef<any>;
  @ViewChild('modalDetails') modalDetails!: TemplateRef<any>;

  // ─── Data ──────────────────────────────────────────────────────────────────
  public typeInterventionData: TypeInterventionResponse[] = [];
  get typeInterventionOptions(): { value: string; label: string }[] {
    return this.typeInterventionData.map(ti => ({ value: ti.id as string, label: ti.libelle }));
  }
  public lowestLevelTypeIntervention: TypeInterventionResponse | null = null;
  public tableProgrammesColumns = TableProgrammes;
  public structures: StructureProgrammatiqueResponse[] = [];
  public sortedStructures: StructureProgrammatiqueResponse[] = [];
  public filteredStructures: StructureProgrammatiqueResponse[] = [];
  public allActivites: ActivtieResponse[] = [];

  // ─── Loading flags ─────────────────────────────────────────────────────────
  public isLoading: boolean = false;
  public isLoadingChild: boolean = false;
  public isTableLoading: boolean = true;

  // ─── Modal visibility ──────────────────────────────────────────────────────
  public showAddStructprogrammatique: boolean = false;
  public showEditStructureModal: boolean = false;
  public showDetailsModal: boolean = false;

  // ─── Form fields ───────────────────────────────────────────────────────────
  public code: string = '';
  public produit: number=0;
  public charge: number=0;
  public poids: number=0;
  public intervention: string = '';
  public typeIntervention: string = '';
  public dateDebut: string = '';
  public dateFin: string = '';
  public caracteristiquesArray: { code: string; valeur: any }[] = [];

  // ─── Add sub-structure ─────────────────────────────────────────────────────
  public newSubStructureTypeId: string = '';
  public newSubStructureLibelle: string = '';
  public modalParentStructureId: string = '';
  public modalParentTypeInterventionId: string = '';
  public modalParentTypeInterventionLibelle: string = '';

  // ─── Edit ──────────────────────────────────────────────────────────────────
  public isEditing: boolean = false;
  public editingStructure: StructureProgrammatiqueResponse | null = null;
  public editStructureLibelle: string = '';
  public editStructureTypeInterventionId: string = '';

  // ─── Details ───────────────────────────────────────────────────────────────
  public detailsStructure: StructureProgrammatiqueResponse | null = null;
  public detailsParentChain: string[] = [];

  // ─── Confirm delete ────────────────────────────────────────────────────────
  public showDeleteConfirm: boolean = false;
  public showDeleteBlocked: boolean = false;
  public deleteTargetId: string | null = null;
  public deleteTargetLabel: string = '';
  public deleteTargetChildCount: number = 0;
  public isDeletingItem: boolean = false;

  // ─── Filters ───────────────────────────────────────────────────────────────
  public searchTerm: string = '';
  public filterStartDate: string = '';
  public filterEndDate: string = '';

  // ─── Misc ──────────────────────────────────────────────────────────────────
  public generaleForm: FormGroup = new FormGroup({});
  public openMenuIndex: number | null = null;

  // ─── Caches ────────────────────────────────────────────────────────────────
  private nonActivityCache: Map<string, StructureProgrammatiqueResponse[]> = new Map();
  private activityCache: Map<string, StructureProgrammatiqueResponse[]> = new Map();
  private groupedActivitiesCache: Map<string, Map<string, StructureProgrammatiqueResponse[]>> = new Map();
  private typeInterventionMap: Map<string, string> = new Map();

  // ─── PERF: flat tree memoization ─────────────────────────────────────────
  /** Cached result of getFlatVisibleNodes() — invalidated on tree/filter/visibility change */
  private _flatCache: FlatNode[] | null = null;

  // ─── PERF: date format cache ─────────────────────────────────────────────
  /** Cache: `${date}__${level}` → formatted string */
  private _dateFormatCache: Map<string, string> = new Map();

  // ─── PERF: type libelle display cache ────────────────────────────────────
  /** Cache: typeActivite id → libelle (already covered by typeInterventionMap) */

  // ─── PERF: showSeeMore cache ──────────────────────────────────────────────
  private _showSeeMoreCache: Map<string, boolean> = new Map();

  // ─── Node ID helpers ───────────────────────────────────────────────────────
  private nodeUid: WeakMap<object, string> = new WeakMap();
  private uidCounter: number = 1;

  // ─── Tree state ────────────────────────────────────────────────────────────
  visibleChildrenIds: Set<string> = new Set();
  expandedTextIds: Set<string> = new Set();

  constructor(
    private structureProgrammatiqueService: StructureProgammatiqueService,
    private typeInterventionService: TypeInterventionService,
    private activiteService: ActiviteService,
    private appService: AppService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.loadTypeIntervention();
    this.loadStructures();
    this.loadActivities();
  }

  // ─── Node key ─────────────────────────────────────────────────────────────

  nodeKey(nodeOrId: any): string {
    if (!nodeOrId) return 'nil';
    if (typeof nodeOrId === 'string') return `id:${nodeOrId}`;
    if (nodeOrId.id) return `id:${String(nodeOrId.id)}`;
    if (nodeOrId.code) return `code:${String(nodeOrId.code)}`;
    if (nodeOrId.titre) {
      return `titre:${String(nodeOrId.titre).replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_\-]/g, '').slice(0, 60)}`;
    }
    if (this.nodeUid.has(nodeOrId)) return this.nodeUid.get(nodeOrId)!;
    const uid = `uid:${this.uidCounter++}`;
    this.nodeUid.set(nodeOrId, uid);
    return uid;
  }

  // ─── Visibility ───────────────────────────────────────────────────────────

  toggleChildrenVisibility(nodeOrId: any): void {
    const key = this.nodeKey(nodeOrId);
    if (this.visibleChildrenIds.has(key)) {
      this.visibleChildrenIds.delete(key);
    } else {
      this.visibleChildrenIds.add(key);
    }
    // PERF: invalidate flat cache on visibility change
    this._flatCache = null;
    try { this.cd.markForCheck(); } catch { }
  }

  isChildrenVisible(nodeOrId: any): boolean {
    return this.visibleChildrenIds.has(this.nodeKey(nodeOrId));
  }

  // ─── Text expansion ───────────────────────────────────────────────────────

  toggleTextExpansion(nodeOrId: any): void {
    const key = this.nodeKey(nodeOrId);
    this.expandedTextIds.has(key) ? this.expandedTextIds.delete(key) : this.expandedTextIds.add(key);
    try { this.cd.markForCheck(); } catch { }
  }

  isTextExpanded(nodeOrId: any): boolean {
    return this.expandedTextIds.has(this.nodeKey(nodeOrId));
  }

  /**
   * PERF: memoized showSeeMore — result cached per `nodeKey + level`
   * Avoids repeated string.length check on every render cycle.
   */
  showSeeMore(node: any, level: number): boolean {
    const k = `${this.nodeKey(node)}__${level}`;
    if (this._showSeeMoreCache.has(k)) return this._showSeeMoreCache.get(k)!;
    const title = node?.titre || '';
    const threshold = level === 0 ? 80 : level === 1 ? 60 : 50;
    const result = title.length > threshold;
    this._showSeeMoreCache.set(k, result);
    return result;
  }

  // ─── TrackBy ──────────────────────────────────────────────────────────────

  trackByNode = (_i: number, item: StructureProgrammatiqueResponse) => this.nodeKey(item);

  /**
   * PERF: trackByFlat uses a stable string key.
   * By returning the same key when nothing changed, Angular skips DOM diffing
   * for unchanged rows — the single biggest win for large trees.
   */
  trackByFlat = (_i: number, item: FlatNode) =>
    `${this.nodeKey(item.node)}__${item.level}__${item.isResponsible}`;

  // ─── Flat tree — MEMOIZED ─────────────────────────────────────────────────

  /**
   * PERF: The flat tree is now memoized in `_flatCache`.
   * It is rebuilt only when:
   *   - `filteredStructures` changes (loadStructures / computeFilteredStructures)
   *   - `visibleChildrenIds` changes (toggleChildrenVisibility)
   *
   * This eliminates the O(n) traversal on EVERY Angular change-detection tick,
   * which was the dominant performance bottleneck of the previous implementation.
   */
  getFlatVisibleNodes(): FlatNode[] {
    if (this._flatCache) return this._flatCache;

    const result: FlatNode[] = [];
    const walk = (nodes: StructureProgrammatiqueResponse[], level: number) => {
      for (const node of nodes) {
        result.push({ node, level, isResponsible: false });
        if (!this.isChildrenVisible(node)) continue;

        walk(this.getNonActivityChildren(node) as StructureProgrammatiqueResponse[], level + 1);

        this.groupActivitiesByResponsibleStructure(node).forEach((activities, responsibleKey) => {
          const syntheticId = this.getResponsibleStructureNodeId(node, responsibleKey);
          const syntheticNode = {
            id: syntheticId, titre: responsibleKey,
            typeActivite: '__RESPONSIBLE__', enfant: activities,
          } as unknown as StructureProgrammatiqueResponse;
          result.push({ node: syntheticNode, level: level + 1, isResponsible: true });
          if (this.isChildrenVisible(syntheticId)) {
            walk(activities as StructureProgrammatiqueResponse[], level + 2);
          }
        });
      }
    };
    walk(this.filteredStructures, 0);

    this._flatCache = result;
    return result;
  }

  getResponsibleStructureNodeId(parentOrId: any, structureName: string): string {
    return `${this.nodeKey(parentOrId)}__resp__${String(structureName || '').replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_\-]/g, '')}`;
  }

  // ─── Load data ────────────────────────────────────────────────────────────

  loadStructures(): void {
    this.isTableLoading = true;
    try { this.cd.markForCheck(); } catch { }
    this.structureProgrammatiqueService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response) => {
        this.structures = this.sortStructuresRecursively(response.data as StructureProgrammatiqueResponse[]);
        this.sortedStructures = [...this.structures];
        this._clearCaches();
        this.computeFilteredStructures();
        this.isTableLoading = false;
        try { this.cd.markForCheck(); } catch { }
      },
      error: (error) => {
        console.error('Erreur chargement structures :', error);
        this.isTableLoading = false;
        try { this.cd.markForCheck(); } catch { }
      },
    });
  }

  sortStructuresRecursively(nodes: any[]): StructureProgrammatiqueResponse[] {
    return nodes
      .map(node => ({
        ...node,
        parent: node.parent && typeof node.parent === 'object' ? (node.parent.id ?? null) : (node.parent ?? null),
        enfant: node.enfant ? this.sortStructuresRecursively(node.enfant) : [],
      }))
      .sort((a, b) => {
        const nA = this.typeInterventionData.find(ti => ti.id === a.typeActivite)?.niveau ?? 0;
        const nB = this.typeInterventionData.find(ti => ti.id === b.typeActivite)?.niveau ?? 0;
        return nA - nB;
      });
  }

  loadTypeIntervention(): void {
    this.typeInterventionService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeInterventionData = response.data;
        this.typeInterventionMap.clear();
        for (const ti of this.typeInterventionData || []) {
          if (ti?.id) this.typeInterventionMap.set(ti.id, ti.libelle);
        }
        this.setLowestLevelTypeIntervention();
        if (this.structures.length) {
          this.computeFilteredStructures();
        }
        try { this.cd.markForCheck(); } catch { }
      },
      error: (e) => console.error('Erreur types intervention :', e),
    });
  }

  setLowestLevelTypeIntervention(): void {
    if (!this.typeInterventionData?.length) {
      this.lowestLevelTypeIntervention = null;
      this.typeIntervention = '';
      return;
    }
    const minNiveau = Math.min(...this.typeInterventionData.map(ti => ti.niveau));
    this.lowestLevelTypeIntervention = this.typeInterventionData.find(ti => ti.niveau === minNiveau) || null;
    this.typeIntervention = this.lowestLevelTypeIntervention?.id as string ?? '';
  }

  loadActivities(): void {
    this.activiteService.getAllByAppIdExcludeRegroupement(this.appService.getAppId()).subscribe({
      next: (response) => {
        this.allActivites = (response.data || []).filter((a: any) => a.typeActivite === 'ACTIVITE');
        try { this.cd.markForCheck(); } catch { }
      },
      error: (e) => console.error('Erreur activités :', e),
    });
  }

  // ─── CRUD ─────────────────────────────────────────────────────────────────

  addStructureProgrammatique(): void {
    if (!this.typeIntervention.trim() || !this.intervention.trim()) return;
    const p = this.structures.filter(s => s.typeActivite === this.typeIntervention);
    this.code = ((p?.length ?? 0) + 1).toString();
    const payload: StructureProgrammatiqueRequest = {
      code: this.code, titre: this.intervention,
      typeActivite: this.typeIntervention, applicationId: this.appService.getAppId(),
    };
    this.isLoading = true;
    this.structureProgrammatiqueService.create(payload).subscribe({
      next: () => {
        this.typeIntervention = this.lowestLevelTypeIntervention?.id as string ?? '';
        this.intervention = '';
        this.loadStructures();
        this.isLoading = false;
      },
      error: (e) => { console.error(e); this.isLoading = false; },
    });
  }

  canAddChild(parent: StructureProgrammatiqueResponse): boolean {
    const parentType = this.typeInterventionData.find(ti => ti.id === parent.typeActivite);
    const activiteType = this.typeInterventionData.find(ti => ti.id === 'ACTIVITE');
    if (!parentType || !activiteType) return false;
    return parentType.niveau + 1 < activiteType.niveau;
  }

  isAtOrBelowActiviteLevel(node?: StructureProgrammatiqueResponse | null): boolean {
    if (!node?.typeActivite || !this.typeInterventionData?.length) return false;
    const activiteType = this.typeInterventionData.find(ti => ti.id === 'ACTIVITE');
    const nodeType = this.typeInterventionData.find(ti => ti.id === node.typeActivite);
    if (!activiteType || !nodeType) return false;
    return nodeType.niveau >= activiteType.niveau;
  }

  isActiviteType(node?: StructureProgrammatiqueResponse | null): boolean {
    return this.isAtOrBelowActiviteLevel(node);
  }

  addSubStructureProgrammatique(): void {
    if (!this.newSubStructureLibelle.trim() || !this.modalParentTypeInterventionId.trim()
      || !this.dateDebut.trim() || !this.dateFin.trim()) return;
    const caracts : Carateristique[] = [];
    console.log(typeof this.poids, typeof this.charge, typeof this.produit);
    console.log('Adding sub-structure with caracteristiques:', { poids: this.poids, charge: this.charge, produit: this.produit });
    if(this.poids && this.poids !== 0) caracts.push({code:'POIDS', valeur: this.poids});
    if(this.charge && this.charge !== 0) caracts.push({code: toSnakeCaseUpper('DecaissementEstimatif'), valeur: this.charge});
    if(this.produit && this.produit !== 0) caracts.push({code: toSnakeCaseUpper('EncaissementEstimatif'), valeur: this.produit});
    const payload: StructureProgrammatiqueRequest = {
      code: this.code, titre: this.newSubStructureLibelle,
      typeActivite: this.newSubStructureTypeId, applicationId: this.appService.getAppId(),
      parent: this.modalParentStructureId,
      dateDebut: formatDate(this.dateDebut, 'yyyy-MM-ddTHH:mm:ss', 'en-US'),
      dateFin: formatDate(this.dateFin, 'yyyy-MM-ddTHH:mm:ss', 'en-US'),
      caracteristiques: caracts,
    };
    this.isLoadingChild = true;
    this.structureProgrammatiqueService.create(payload).subscribe({
      next: () => {
        this.loadStructures();
        this.closeAddSubStructureModal();
        this.isLoadingChild = false;
      },
      error: (e) => { console.error(e); this.isLoadingChild = false; },
    });
  }

  saveEditedStructure(): void {
    if (!this.editingStructure || !this.editStructureLibelle.trim()
      || !this.editStructureTypeInterventionId.trim()) return;

    this.isLoading = true;

    const formattedDebut = this.dateDebut?.trim()
      ? formatDate(this.dateDebut, 'yyyy-MM-ddTHH:mm:ss', 'en-US')
      : null;
    const formattedFin = this.dateFin?.trim()
      ? formatDate(this.dateFin, 'yyyy-MM-ddTHH:mm:ss', 'en-US')
      : null;

    const caracts : Carateristique[] = [];
    if(this.poids && this.poids !== 0) caracts.push({code:'POIDS', valeur: this.poids});
    if(this.charge && this.charge !== 0) caracts.push({code: toSnakeCaseUpper('DecaissementEstimatif'), valeur: this.charge});
    if(this.produit && this.produit !== 0) caracts.push({code: toSnakeCaseUpper('EncaissementEstimatif'), valeur: this.produit});
    const payload: StructureProgrammatiqueRequest = {
      code: this.code || this.editingStructure.code,
      titre: this.editStructureLibelle,
      typeActivite: this.editStructureTypeInterventionId,
      applicationId: this.appService.getAppId(),
      parent: this.editingStructure.parent!,
      dateDebut: formattedDebut as any,
      dateFin: formattedFin as any,
      caracteristiques: caracts,
    };

    this.structureProgrammatiqueService.update(this.editingStructure.id as string, payload).subscribe({
      next: () => {
        this.loadStructures();
        this.closeEditStructureModal();
        this.isLoading = false;
        try { this.cd.markForCheck(); } catch { }
      },
      error: (e) => {
        console.error('Erreur mise à jour :', e);
        this.isLoading = false;
        try { this.cd.markForCheck(); } catch { }
      },
    });
  }

  openDeleteConfirm(node: StructureProgrammatiqueResponse): void {
    this.deleteTargetLabel = node.titre || '(sans titre)';
    const childCount = node.enfant?.length ?? 0;
    if (childCount > 0) {
      this.deleteTargetChildCount = childCount;
      this.showDeleteBlocked = true;
      try { this.cd.markForCheck(); } catch { }
      return;
    }
    this.deleteTargetId = node.id as string;
    this.showDeleteConfirm = true;
    try { this.cd.markForCheck(); } catch { }
  }

  closeDeleteBlocked(): void {
    this.showDeleteBlocked = false;
    this.deleteTargetLabel = '';
    this.deleteTargetChildCount = 0;
    try { this.cd.markForCheck(); } catch { }
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.deleteTargetId = null;
    this.deleteTargetLabel = '';
    try { this.cd.markForCheck(); } catch { }
  }

  confirmDelete(): void {
    if (!this.deleteTargetId) return;
    this.isDeletingItem = true;
    try { this.cd.markForCheck(); } catch { }
    this.structureProgrammatiqueService.delete(this.deleteTargetId).subscribe({
      next: () => {
        this.loadStructures();
        this.showDeleteConfirm = false;
        this.deleteTargetId = null;
        this.deleteTargetLabel = '';
        this.isDeletingItem = false;
        this.openMenuIndex = null;
        try { this.cd.markForCheck(); } catch { }
      },
      error: (e) => {
        console.error('Erreur suppression :', e);
        this.isDeletingItem = false;
        try { this.cd.markForCheck(); } catch { }
      },
    });
  }

  // ─── Modals ───────────────────────────────────────────────────────────────

  openAddSubStructureModal(parentStructure: StructureProgrammatiqueResponse): void {
    if (this.isActiviteType(parentStructure) || !this.canAddChild(parentStructure)) return;
    this.modalParentStructureId = parentStructure.id as string;
    this.modalParentTypeInterventionLibelle = parentStructure.typeActivite as string;
    const parentType = this.typeInterventionData.find(ti => ti.id === parentStructure.typeActivite);
    if (!parentType) return;
    const childType = this.typeInterventionData.find(ti => ti.niveau === parentType.niveau + 1);
    this.modalParentTypeInterventionId = parentType.id as string;
    this.newSubStructureTypeId = childType?.id as string ?? '';
    this.newSubStructureLibelle = '';
    this.dateDebut = '';
    this.poids = 0; this.charge = 0; this.produit = 0;
    this.dateFin = '';
    this.code = this.getSubInterventionCode(parentStructure);
    this.showAddStructprogrammatique = true;
  }

  closeAddSubStructureModal(): void {
    this.showAddStructprogrammatique = false;
    this.modalParentStructureId = '';
    this.newSubStructureTypeId = '';
    this.modalParentTypeInterventionId = '';
    this.modalParentTypeInterventionLibelle = '';
    this.newSubStructureLibelle = '';
    this.poids = 0; this.charge = 0; this.produit = 0;
    this.code = ''; this.dateDebut = ''; this.dateFin = '';
  }

  openEditStructureModal(structure: StructureProgrammatiqueResponse): void {
    if (this.isActiviteType(structure)) return;
    this.isEditing = true;
    this.editingStructure = structure;
    this.code = structure.code || '';
    this.editStructureLibelle = structure.titre;
    this.dateDebut = structure.dateDebut ? new Date(structure.dateDebut).toISOString().split('T')[0] : '';
    this.dateFin = structure.dateFin ? new Date(structure.dateFin).toISOString().split('T')[0] : '';
    this.setCaracteristiqueValue(structure);
    const ti = this.typeInterventionData.find(t => t.id === structure.typeActivite);
    this.editStructureTypeInterventionId = ti?.id as string ?? '';
    this.showEditStructureModal = true;
    try { this.cd.markForCheck(); } catch { }
  }

  setCaracteristiqueValue(structure: StructureProgrammatiqueResponse): void {
    if (!structure?.caracteristiques) return ;
    this.poids = structure.caracteristiques.find(c => c.code === 'POIDS')?.valeur || 0;
    this.charge = structure.caracteristiques.find(c => c.code === 'DECAISSEMENT_ESTIMATIF')?.valeur || 0;
    this.produit = structure.caracteristiques.find(c => c.code === 'ENCAISSEMENT_ESTIMATIF')?.valeur || 0;
  }

  closeEditStructureModal(): void {
    this.showEditStructureModal = false;
    this.isEditing = false;
    this.editingStructure = null;
    this.editStructureLibelle = '';
    this.code = ''; this.editStructureTypeInterventionId = '';
    this.poids = 0; this.charge = 0; this.produit = 0;
    this.dateDebut = ''; this.dateFin = '';
  }

  openDetailsModal(structure: StructureProgrammatiqueResponse): void {
    if (this.isActiviteType(structure)) return;
    this.detailsStructure = structure;
    this.detailsParentChain = this.getParentChain(structure.parent, 3);
    this.setCaracteristiqueValue(structure);
    this.showDetailsModal = true;
  }

  closeDetailsModal(): void {
    this.showDetailsModal = false;
    this.detailsStructure = null;
    this.detailsParentChain = [];
    this.poids = 0; this.charge = 0; this.produit = 0;
  }

  setOpenMenuIndex(index: number | null): void { this.openMenuIndex = index; }

  // ─── Filter handlers ──────────────────────────────────────────────────────

  onFilterChange(value: SearchFilterValue): void {
    this.searchTerm = value.searchTerm;
    this.filterStartDate = value.startDate;
    this.filterEndDate = value.endDate;
    this.computeFilteredStructures();
    try { this.cd.markForCheck(); } catch { }
  }

  onFilterReset(): void {
    this.searchTerm = ''; this.filterStartDate = ''; this.filterEndDate = '';
    this.computeFilteredStructures();
    try { this.cd.markForCheck(); } catch { }
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────

  /**
   * PERF: O(1) lookup via pre-built Map (unchanged from original).
   * Called in template — already fast, no change needed.
   */
  getTypeInterventionLibelle(typeId: string | undefined): string {
    if (!typeId) return 'Non défini';
    return this.typeInterventionMap.get(typeId) || 'Type non trouvé';
  }

  private findStructureById(id: string | undefined | null, nodes = this.structures): StructureProgrammatiqueResponse | null {
    if (!id) return null;
    for (const node of nodes) {
      if (node.id === id) return node;
      if (node.enfant?.length) {
        const found = this.findStructureById(id, node.enfant as StructureProgrammatiqueResponse[]);
        if (found) return found;
      }
    }
    return null;
  }

  getParentChain(parentId: string | undefined | null, limit = 2): string[] {
    const result: string[] = [];
    let currentId = parentId;
    while (currentId && result.length < limit) {
      const p = this.findStructureById(currentId);
      if (!p) break;
      result.push(p.titre || '(sans titre)');
      currentId = (p.parent as any) || null;
    }
    return result;
  }

  getSubInterventionCode(parent: StructureProgrammatiqueResponse, initialValue?: string): string {
    const result = initialValue ?? ((parent.enfant?.length ?? 0) + 1).toString();
    return (parent.code || '') + (result ? '.' + result : '');
  }

  getInterventionCode(parent: StructureProgrammatiqueResponse): string {
    if (parent.code) return parent.code;
    const parentStructure = this.findStructureById(parent.parent as any);
    let p = this.structures.filter(s => s.typeActivite === parent.typeActivite && s.code);
    let prefix = '';
    if (parentStructure) {
      p = (parentStructure.enfant as StructureProgrammatiqueResponse[] || []).filter(s => s.code);
      prefix = parentStructure.code + '.';
    }
    return prefix + ((p?.length ?? 0) + 1).toString();
  }

  formatDetailDate(date?: string | null): string {
    if (!date) return '—';
    try { return formatDate(date, 'dd/MM/yyyy', 'en-US'); } catch { return String(date); }
  }

  /**
   * PERF: memoized date formatter.
   * `formatDate()` is expensive (locale parsing, string construction).
   * Caching by `${date}__${level}` eliminates repeated calls for the same value
   * across render cycles — especially relevant for large trees with shared dates.
   */
  formatDateFR(date?: string | null, level?: number): string {
    if (!date) return '';
    const cacheKey = `${date}__${level ?? 'x'}`;
    if (this._dateFormatCache.has(cacheKey)) return this._dateFormatCache.get(cacheKey)!;

    let result = '';
    try {
      const mois = ['jan', 'fév', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];
      const d = new Date(date);
      if (isNaN(d.getTime())) {
        result = String(date);
      } else {
        const trimestre = Math.floor(d.getMonth() / 3) + 1;
        switch (level) {
          case 0: result = `${d.getFullYear()}`; break;
          case 1: result = `T${trimestre}`; break;
          case 2: result = `${mois[d.getMonth()]}`; break;
          default: result = `${d.getDate()} ${mois[d.getMonth()]} ${d.getFullYear()}`; break;
        }
      }
    } catch { result = String(date); }

    this._dateFormatCache.set(cacheKey, result);
    return result;
  }

  isActivityNode(node: StructureProgrammatiqueResponse): boolean {
    return node.typeActivite === 'ACTIVITE';
  }

  getActivityResponsibleStructure(activite: StructureProgrammatiqueResponse): string | null {
    const c = (activite as any).caracteristiques?.find((x: any) => x.code === 'STRUCTURE_RESPONSABLE');
    return c ? c.valeur : null;
  }

  getNonActivityChildren(node: StructureProgrammatiqueResponse): StructureProgrammatiqueResponse[] {
    if (!node) return [];
    const key = this.nodeKey(node);
    if (this.nonActivityCache.has(key)) return this.nonActivityCache.get(key)!;
    const result = (node.enfant || []).filter(c => !this.isActivityNode(c));
    this.nonActivityCache.set(key, result);
    return result;
  }

  groupActivitiesByResponsibleStructure(node: StructureProgrammatiqueResponse): Map<string, StructureProgrammatiqueResponse[]> {
    if (!node) return new Map();
    const key = this.nodeKey(node);
    if (this.groupedActivitiesCache.has(key)) return this.groupedActivitiesCache.get(key)!;
    const grouped = new Map<string, StructureProgrammatiqueResponse[]>();
    (node.enfant || []).filter(c => this.isActivityNode(c)).forEach(activity => {
      const rs = this.getActivityResponsibleStructure(activity as any);
      if (rs) {
        if (!grouped.has(rs)) grouped.set(rs, []);
        grouped.get(rs)!.push(activity as any);
      }
    });
    this.groupedActivitiesCache.set(key, grouped);
    return grouped;
  }

  // ─── Filters ──────────────────────────────────────────────────────────────

  computeFilteredStructures(): void {
    // PERF: invalidate flat cache whenever filter state changes
    this._flatCache = null;
    this._clearCaches();

    const filterNode = (node: StructureProgrammatiqueResponse): StructureProgrammatiqueResponse | null => {
      const children = (node.enfant || []).map(filterNode).filter((c): c is StructureProgrammatiqueResponse => c !== null);
      const titleMatch = !this.searchTerm || (node.titre || '').toLowerCase().includes(this.searchTerm.toLowerCase());
      let dateMatch = true;
      if (this.filterStartDate || this.filterEndDate) {
        const start = this.filterStartDate ? this._parseLocalDate(this.filterStartDate) : null;
        const end = this.filterEndDate ? this._parseLocalDate(this.filterEndDate) : null;
        if (end) end.setHours(23, 59, 59, 999);
        const ns = node.dateDebut ? new Date(node.dateDebut) : null;
        const ne = node.dateFin ? new Date(node.dateFin) : ns;
        if (!ns) { dateMatch = false; }
        else {
          if (start && ne && ne < start) dateMatch = false;
          if (end && ns > end) dateMatch = false;
        }
      }
      return (titleMatch && dateMatch) || children.length > 0 ? { ...node, enfant: children } as StructureProgrammatiqueResponse : null;
    };

    if (!this.searchTerm && !this.filterStartDate && !this.filterEndDate) {
      this.filteredStructures = (this.structures || []).map(filterNode).filter((s): s is StructureProgrammatiqueResponse => s !== null);
      return;
    }
    const start = this.filterStartDate ? this._parseLocalDate(this.filterStartDate) : null;
    const end = this.filterEndDate ? this._parseLocalDate(this.filterEndDate) : null;
    if (end) end.setHours(23, 59, 59, 999);

    this.filteredStructures = (this.structures || []).map(filterNode).filter((s): s is StructureProgrammatiqueResponse => s !== null);
  }

  // ─── Private ──────────────────────────────────────────────────────────────

  private _clearCaches(): void {
    this.nonActivityCache.clear();
    this.activityCache.clear();
    this.groupedActivitiesCache.clear();
    // PERF: also clear derivative caches that depend on tree shape
    this._showSeeMoreCache.clear();
    this._dateFormatCache.clear();
    this._flatCache = null;
  }

  private _parseLocalDate(dateStr: string): Date {
    const [y, m, d] = dateStr.split('-').map(Number);
    return new Date(y, m - 1, d);
  }

  openDatePicker(el: HTMLInputElement | null | undefined): void {
    if (!el) return;
    try {
      const a = el as any;
      if (typeof a.showPicker === 'function') { a.showPicker(); return; }
      el.focus();
    } catch { try { el.focus(); } catch { } }
  }
}